export default { ROOT: "ErrorPagePanel", BODY: "ErrorPagePanelBody" };
